import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SchoolWebLinkViewModel } from 'src/app/models/school.model';

@Component({
  selector: 'app-quicklink',
  templateUrl: './quicklink.component.html',
  styleUrls: ['./quicklink.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class QuicklinkComponent {
  @Input() quicklink: SchoolWebLinkViewModel;
  fallbackIcon = 'quicklinkIcon';

  constructor(public sanitizer: DomSanitizer) {}

  generateQuicklinkURL(iconUrl: string, url: string): string {
    if (url.startsWith('http')) return url;
    if (url.startsWith('mailto')) return url;
    if (url.includes('@')) {
      return `mailto:${url}`;
    }

    return url;
  }
}
